<h2 mat-dialog-title>Select Verse</h2>
<mat-dialog-content>
    <form [formGroup]="form" (keydown.enter)="go()">
        <mat-form-field class="canon-select">
            <mat-label>Canon</mat-label>
            <mat-select formControlName="canon">
            @for (canon of project?.canons; track canon) {
                <mat-option [value]="canon">{{canon}}</mat-option>
            }
            </mat-select>
        </mat-form-field>
        <mat-form-field>
            <mat-label>Book</mat-label>
            <mat-select formControlName="book" (valueChange)="bookChanged()">
            @for (book of bookCodes; track book) {
                <mat-option [value]="book">{{bookName(book)}}</mat-option>
            }
            </mat-select>
        </mat-form-field>
        <mat-form-field class="narrow">
            <mat-label>Chapter</mat-label>
            <input matInput type="number" formControlName="chapter" min="1" [max]="maxChapter" (change)="chapterChanged()">
        </mat-form-field>
        <mat-form-field class="narrow">
            <mat-label>Verse</mat-label>
            <input matInput type="number" formControlName="verse" min="1" [max]="maxVerse" (change)="this.form.updateValueAndValidity()">
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="dismiss()">Dismiss</button>
  <button mat-flat-button color="primary" (click)="go()" cdkFocusInitial [disabled]="!form.valid">Go</button>
</mat-dialog-actions>
